"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.repeatString = exports.repeatArray = void 0;
const repeatArray = (arr, count, seperator) => {
    let repeated = [];
    for (let index = 0; index < count; index++) {
        repeated = repeated.concat(arr);
        if (seperator != null && index !== count - 1) {
            repeated.push(seperator);
        }
    }
    return repeated;
};
exports.repeatArray = repeatArray;
const repeatString = (str, count, seperator) => {
    let repeated = '';
    for (let index = 0; index < count; index++) {
        repeated = repeated + str;
        if (seperator != null && index !== count - 1) {
            repeated = repeated + seperator;
        }
    }
    return repeated;
};
exports.repeatString = repeatString;
